<template>
  <div>
    <div
      class="row"
      style="display: flex; justify-content: center;"
    >
      <div class="col-12 col-md-10 col-lg-5 col-xl-6">
        <div class="my-card">
          <div class="my-card-title text-center">Verify your account</div>
          <div class="my-card-body">
            <!-- Step 1 -->
            <div
              v-if="step  == 1"
              class="row"
            >
              <div class="col-sm-12">
                <v-alert
                  :value="phoneError.length > 0"
                  color="error"
                >
                  {{ phoneError }}
                </v-alert>
              </div>

              <div class="col-sm-1">
                <div style="padding-top: 20px; font-size: 16px">+964</div>
              </div>
              <div class="col-sm-11">
                <v-text-field
                  label="Phone Number"
                  v-model="phone_number"
                  :error-messages="errors.collect('Phone Number')"
                  placeholder="7701234567"
                  v-validate="'required'"
                  data-vv-name="Phone Number"
                  hide-details
                />
              </div>
              <div class="col-sm-12 pt-4 text-center">
                <v-btn
                  style="height: auto; border-radius: 8px;"
                  color="primary"
                  depressed
                  :disabled="!phone_number || phone_number.length != 10"
                  :loading="loading"
                  @click="submit1()"
                >
                  Next
                </v-btn>
              </div>
            </div>

            <!-- Step 2 -->

            <div
              v-if="step  == 2"
              class="row"
            >
              <div class="col-sm-12">
                <vue-otp-2
                  length="6"
                  join-character="-"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  @onComplete="handleCompleteOtp"
                />
              </div>
              <div class="col-sm-12 pt-4 text-center">
                <v-btn
                  style="height: auto; border-radius: 8px;"
                  color="primary"
                  depressed
                  :disabled="!otpCode || otpCode.length != 6"
                  :loading="loading"
                  @click="submit2()"
                >
                  Next
                </v-btn>
              </div>
            </div>

            <!-- Step 3 -->
            <form
              v-if="step == 3"
              @submit.prevent="submit3()"
            >
              <div class="row">
                <div class="col-sm-12">
                  <v-text-field
                    label="Full Name"
                    v-model="customer.full_name"
                    :error-messages="errors.collect('Full Name')"
                    v-validate="'required'"
                    data-vv-name="Full Name"
                  />
                </div>
                <div class="col-sm-12">
                  <v-text-field
                    label="Email"
                    v-model="customer.email"
                    :error-messages="errors.collect('Email')"
                    v-validate="'required|email'"
                    data-vv-name="Email"
                  />
                </div>
                <div class="col-sm-12">
                  <v-text-field
                    label="Address"
                    v-model="customer.address"
                    :error-messages="errors.collect('Address')"
                    v-validate="'required'"
                    data-vv-name="Address"
                  />
                </div>
                <div class="col-sm-12">
                  <v-text-field
                    label="Password"
                    v-model="customer.password"
                    :error-messages="errors.collect('Password')"
                    v-validate="'required|min:6'"
                    data-vv-name="Password"
                  />
                </div>
                <div class="col-sm-12">
                  <v-text-field
                    label="Confirm Password"
                    v-model="customer.confirm_password"
                    :error-messages="errors.collect('Confirm Password')"
                    v-validate="'required|min:6'"
                    data-vv-name="Confirm Password"
                  />
                </div>
                <div
                  v-if="passwordNotMatch"
                  class="col-sm-12"
                >
                  <v-alert
                    :value="true"
                    type="error"
                  >
                    Confirm Password not match with Password
                  </v-alert>
                </div>
                <div class="col-sm-12 pt-4 text-center">
                  <v-btn
                    style="height: auto; border-radius: 8px;"
                    color="primary"
                    depressed
                    type="submit"
                    :loading="loading"
                  >
                    Submit
                  </v-btn>
                </div>
              </div>
            </form>

            <!-- Step 4 -->
            <div
              v-if="step  == 4"
              class="container"
            >
              <div class="congrats-box">
                <div class="custom-icon">🎉</div>
                <h1>Congratulations!</h1>
                <p>Your account has been verified successfully.</p>
                <!-- <v-btn
                  class="rounded-pill custom-btn px-6"
                  style="height: auto; text-transform: none; letter-spacing: 0.5px"
                  @click="downloadApp()"
                >
                  Download ShipZone App
                </v-btn> -->
                <v-btn
                  class="rounded-pill custom-btn px-6"
                  style="height: auto; text-transform: none; letter-spacing: 0.5px"
                  @click="backToHome()"
                >
                  Back To Home
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
export default {
  data() {
    return {
      loading: false,
      step: 1,
      phone_number: null,
      otpCode: '',
      phoneError: '',
      passwordNotMatch: false,
      customer: {
        full_name: null,
        email: null,
        dob: null,
        address: null,
        password: null,
        confirm_password: null
      }
    }
  },

  methods: {
    submit1() {
      this.$validator.validateAll().then(() => {
        this.loading = true
        let token = localStorage.getItem('access_token')

        let payload = {
          phone_number: `+964${this.phone_number}`
        }
        Axios.post('api/website-verify-phone-number', payload, { headers: { Authorization: 'Bearer ' + token } }).then(() => {
          this.step = 2
        }).catch(err => {
          this.phoneError = err.response.data.message
        }).finally(() => {
          this.loading = false
        })
      })
    },

    handleCompleteOtp(val) {
      this.otpCode = val.join('')
      this.submit2()
    },

    submit2() {
      this.loading = true
      let token = localStorage.getItem('access_token')

      let payload = {
        phone_number: `+964${this.phone_number}`,
        otp_code: this.otpCode
      }
      Axios.post('api/website-verify-otp-code', payload, { headers: { Authorization: 'Bearer ' + token } }).then(res => {
        this.customer = res.data
        this.step = 3
      }).finally(() => {
        this.loading = false
      })
    },

    submit3() {
      this.passwordNotMatch = false
      // check if password match with confirm password
      if (this.customer.password !== this.customer.confirm_password) {
        this.passwordNotMatch = true
        return
      }

      this.$validator.validateAll().then((valid) => {
        if (valid) {
          this.loading = true
          let token = localStorage.getItem('access_token')

          Axios.post('api/website-verify-customer', this.customer, { headers: { Authorization: 'Bearer ' + token } }).then(() => {
            this.step = 4
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },

    downloadApp() {
      window.open('https://onelink.to/u4amdf')
    },

    backToHome() {
      this.$router.push('/')
    }
  }
}
</script>

<style >
.my-card {
  border: 1px solid #ddd;
  margin-top: 16px;
  padding: 16px;
  border-radius: 16px;
}
.my-card-title {
  font-size: 20px;
  font-weight: 500;
}
.my-card-body {
  padding: 16px;
}

.vue-otp-2 div input {
  max-width: 50px !important;
  padding: 11.5px 8px;
  font-size: 20px;
  border-radius: 8px !important;
  border: 1px solid #cecece;
  text-align: center;
}

.container {
  max-width: 400px;
  margin: auto;
}

.congrats-box {
  background: linear-gradient(135deg, #006b8d, #00455b);
  padding: 40px;
  border-radius: 15px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  text-align: center;
  animation: fadeIn 1s ease-in-out;
}

.custom-icon {
  font-size: 60px;
  opacity: 1 !important;
  animation: bounce 1.5s infinite;
}

h1 {
  font-size: 2.5em;
  margin: 20px 0;
  color: white !important;
}

p {
  font-size: 1.2em;
  color: white !important;
  margin-bottom: 30px;
}

.custom-btn {
  padding: 12px 30px;
  color: white;
  border: none;
  border-radius: 25px;
  font-size: 1em;
  text-decoration: none;
  transition: background-color 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes bounce {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/customerVerification/CustomerVerification.vue